import config from "config"
import httpService from "services/httpService"

const endpoint = `${config.api}/User`

export async function getUser() {
  return {
    title: null,
    firstName: null,
    surname: null,
    email: null,
    mobileNumber: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    addressLine4: null,
    postCode: null,
    countryCode: null,
    countries: null,
    role: null,
    isAdmin: false,
    isAuthenticated: false,
    responseMessage: null,
    responseType: "SUCCESS",
    id: null,
  }
}

export async function updateUser(user) {
  const data = await httpService.post(`${endpoint}/UpdateUser`, user)
  return data
}
